import React from 'react';
import I18n from 'i18n-js';

import { RCSwitch, RCTag, RCTooltip } from '@reverbdotcom/cadence/components';
import { ArrowSquareOutIcon } from '@reverbdotcom/cadence/icons/react';

export interface IProps {
  mfaEnabled: boolean;
  phoneVerificationPath: string;
  learnMorePath: string;
  mfaEnrollmentRequired?: boolean;
}

export function MFASecurity({ mfaEnabled, phoneVerificationPath, learnMorePath, mfaEnrollmentRequired = false }: IProps) {
  function handleToggle() {
    if (!mfaEnabled) {
      window.location.href = phoneVerificationPath;
    }
  }

  const label = (
    <span style={{ fontSize: 'var(--rc-font-size-400)', display: 'inline-flex', alignItems: 'center' }}>
      {I18n.t('discovery.mfaSecurity.multiFactorLabel')}
      <span className="mr-3" />
      <RCTag variant="highlight">
        {mfaEnrollmentRequired
          ? I18n.t('discovery.mfaSecurity.required')
          : I18n.t('discovery.mfaSecurity.recommended')}
      </RCTag>
    </span>
  );

  const sublabel = (
    <span style={{ fontSize: 'var(--rc-font-size-350)' }}>
      {mfaEnrollmentRequired
        ? I18n.t('discovery.mfaSecurity.multiFactorDescriptionRequired')
        : I18n.t('discovery.mfaSecurity.multiFactorDescription')}
      <a
        href={learnMorePath}
        target="_blank"
        rel="noreferrer"
        style={{ display: 'block', marginTop: 'var(--rc-space-2)', color: 'var(--rc-color-text-primary)', textDecoration: 'none' }}
      >
        <span style={{ textDecoration: 'underline' }}>{I18n.t('discovery.mfaSecurity.learnMore')}</span>
        {' '}
        <ArrowSquareOutIcon style={{ width: '1em', height: '1em', verticalAlign: 'middle' }} />
      </a>
    </span>
  );

  const switchEl = (
    <RCSwitch
      checked={mfaEnabled}
      disabled={mfaEnabled}
      label={label}
      sublabel={sublabel}
      onChange={handleToggle}
    />
  );

  if (mfaEnabled) {
    return (
      <div className="scaling-mb-4 scaling-mt-2">
        <RCTooltip
          text={I18n.t('discovery.mfaSecurity.disabledTooltip')}
          type="plain"
          placement="top-start"
        >
          <span style={{ display: 'inline-block' }}>
            {switchEl}
          </span>
        </RCTooltip>
      </div>
    );
  }

  return (
    <div className="scaling-mb-4 scaling-mt-2">
      {switchEl}
    </div>
  );
}

export default MFASecurity;
